// extracted by mini-css-extract-plugin
module.exports = {"colors":"'styles/colors.module.css'","SUB_TEXT_GREY":"#7C7C7C","container":"styles_container__vLO2s","labelWrapper":"styles_labelWrapper__kKzU3","subText":"styles_subText__O3etM"};